import { Controller } from "stimulus";
import copy from "copy-to-clipboard";
import Popover from "bootstrap/js/dist/popover";

export default class ClipboardsController extends Controller {
  static targets = ["input", "button"];
  popover: Popover;
  buttonTarget: HTMLButtonElement;
  inputTarget: HTMLInputElement;

  connect() {
    this.popover = Popover.getInstance(this.buttonTarget);
  }

  copy() {
    this.buttonTarget?.classList.add("copying");
    copy((this.inputTarget as HTMLInputElement).value);

    setTimeout(() => {
      this.popover?.hide();
      this.buttonTarget?.classList.remove("copying");
    }, 5000);
  }
}
